"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormScreen = void 0;

var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactRouterDom = require("react-router-dom");

var _queryString = _interopRequireDefault(require("query-string"));

var _reduxForm = require("redux-form");

var _reactHelmet = require("react-helmet");

var _reactGoogleRecaptchaV = require("react-google-recaptcha-v3");

var _novaFrontendRestClient = require("@an/nova-frontend-rest-client");

var _config = require("../config");

var _utils = require("../utils");

var _asyncValidateEmail = require("../validation/async/asyncValidateEmail");

var _parseResponseError = _interopRequireDefault(require("../utils/parseResponseError"));

var _setEcommerceTracking = _interopRequireDefault(require("../utils/setEcommerceTracking"));

var _Form = _interopRequireDefault(require("../form/Form"));

var _Button = _interopRequireDefault(require("../form/Button"));

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("dispatch", _flowRuntime["default"]["function"](_flowRuntime["default"].param("_arg0", _flowRuntime["default"].any()), _flowRuntime["default"]["return"](_flowRuntime["default"].any()))), _flowRuntime["default"].property("location", _flowRuntime["default"].object()), _flowRuntime["default"].property("match", _flowRuntime["default"].object())));

var initialState = {
  form: undefined,
  formError: undefined,
  loading: true,
  queryParams: undefined,
  sampleIdError: undefined,
  submitted: false
};

var convertToReduxFormErrors = function convertToReduxFormErrors(payload) {
  var errors = {};

  if (payload.globalErrors && payload.globalErrors.length > 0) {
    var error = payload.globalErrors[0]; // eslint-disable-next-line no-underscore-dangle

    errors._error = error;
  }

  if (payload.fieldErrors && payload.fieldErrors.length > 0) {
    payload.fieldErrors.forEach(function (fieldError) {
      if (fieldError.errors && fieldError.errors.length > 0) {
        var _error = fieldError.errors[0];
        errors[fieldError.key] = _error;
      }
    });
    return (0, _utils.unflatten)(errors);
  }

  return errors;
};

var FormScreen = function FormScreen(_arg) {
  var dispatch = _arg.dispatch,
      location = _arg.location,
      match = _arg.match;

  var _React$useState = _react["default"].useState(initialState),
      _React$useState2 = (0, _slicedToArray2["default"])(_React$useState, 2),
      state = _React$useState2[0],
      setState = _React$useState2[1];

  var form = state.form,
      formError = state.formError,
      loading = state.loading,
      queryParams = state.queryParams,
      sampleIdError = state.sampleIdError,
      submitted = state.submitted;
  (0, _react.useEffect)(function () {
    var queryStringObject = _queryString["default"].parse(location.search);

    var isValidSampleId = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
        var sampleIdValidateUrl, response, sampleIdCheck;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                sampleIdValidateUrl = (0, _config.getSampleIdValidateUrl)().replace('{sampleId}', atob(queryStringObject.sm));
                _context.next = 3;
                return fetch(sampleIdValidateUrl);

              case 3:
                response = _context.sent;

                if (!(response && response.ok)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 7;
                return response.json();

              case 7:
                sampleIdCheck = _context.sent;

                if (!(sampleIdCheck.sampleUsed === true)) {
                  _context.next = 11;
                  break;
                }

                setState(function (prevState) {
                  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                    sampleIdError: {
                      message: 'The Sample ID scanned has already been used!'
                    }
                  });
                });
                return _context.abrupt("return", false);

              case 11:
                _context.next = 15;
                break;

              case 13:
                setState(function (prevState) {
                  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                    sampleIdError: {
                      message: 'There has been an error validating your Sample ID.'
                    }
                  });
                });
                return _context.abrupt("return", false);

              case 15:
                return _context.abrupt("return", true);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function isValidSampleId() {
        return _ref.apply(this, arguments);
      };
    }();

    var fetchForm = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
        var formId, response;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formId = match.params.id;
                _context2.next = 3;
                return dispatch((0, _novaFrontendRestClient.get)("".concat((0, _config.getApiBaseUrl)(), "/forms/").concat(formId), 'form', {
                  formId: formId
                }));

              case 3:
                response = _context2.sent;
                setState(function (prevState) {
                  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                    form: response.response.ok ? response.payload : undefined,
                    formError: (0, _parseResponseError["default"])(response),
                    loading: false,
                    queryParams: queryStringObject
                  });
                });

                window.onbeforeunload = function () {
                  return true;
                };

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function fetchForm() {
        return _ref2.apply(this, arguments);
      };
    }();

    var initialiseForm = /*#__PURE__*/function () {
      var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!queryStringObject.sm) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return isValidSampleId();

              case 3:
                if (!_context3.sent) {
                  _context3.next = 5;
                  break;
                }

                fetchForm();

              case 5:
                _context3.next = 8;
                break;

              case 7:
                fetchForm();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function initialiseForm() {
        return _ref3.apply(this, arguments);
      };
    }();

    initialiseForm();
    return function () {
      window.onbeforeunload = undefined;
    };
  }, [dispatch, location.search, match.params.id]);

  var onSubmit = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5(values, page, nextPage) {
      var formId, isLastPage, response, eventId, sampleId, confirmationCode, postSampleId, formValues, _values$discoveryMeth, isPaymentForm, eventTrackingEnabled, errors, otherError;

      return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              formId = match.params.id;
              isLastPage = form && page === form.pages.length;
              response = '';
              eventId = queryParams && queryParams.ev && atob(queryParams.ev);
              sampleId = queryParams && queryParams.sm && atob(queryParams.sm);
              confirmationCode = eventId && sampleId ? "CC".concat(eventId.slice(-3)).concat(sampleId.slice(-4)) : 'CC-not-set';

              postSampleId = /*#__PURE__*/function () {
                var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
                  var sampleIdPostUrl, sampleIdPostResponse, errorMessage;
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          sampleIdPostUrl = (0, _config.getSampleIdPostUrl)();
                          _context4.next = 3;
                          return fetch(sampleIdPostUrl, {
                            method: 'POST',
                            body: JSON.stringify({
                              sampleId: sampleId
                            }),
                            headers: {
                              Accept: 'application/json',
                              'Content-Type': 'application/json'
                            }
                          })["catch"](function (error) {
                            var errorMessage = 'Sorry, we have not been able to validate your Sample ID.';
                            setState(function (prevState) {
                              return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                                sampleIdError: {
                                  message: errorMessage
                                }
                              });
                            }); // eslint-disable-next-line no-console

                            console.error('Error', error);
                            throw new _reduxForm.SubmissionError({
                              _error: errorMessage
                            });
                          });

                        case 3:
                          sampleIdPostResponse = _context4.sent;

                          if (!(sampleIdPostResponse && sampleIdPostResponse.ok)) {
                            _context4.next = 12;
                            break;
                          }

                          _context4.t0 = console;
                          _context4.next = 8;
                          return sampleIdPostResponse.text();

                        case 8:
                          _context4.t1 = _context4.sent;

                          _context4.t0.log.call(_context4.t0, _context4.t1);

                          _context4.next = 22;
                          break;

                        case 12:
                          if (!sampleIdPostResponse) {
                            _context4.next = 18;
                            break;
                          }

                          _context4.next = 15;
                          return sampleIdPostResponse.text();

                        case 15:
                          _context4.t2 = _context4.sent;
                          _context4.next = 19;
                          break;

                        case 18:
                          _context4.t2 = 'Unknown error';

                        case 19:
                          errorMessage = _context4.t2;
                          setState(function (prevState) {
                            return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                              sampleIdError: {
                                message: errorMessage
                              }
                            });
                          });
                          throw new _reduxForm.SubmissionError({
                            _error: errorMessage
                          });

                        case 22:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function postSampleId() {
                  return _ref5.apply(this, arguments);
                };
              }();

              if (!isLastPage) {
                _context5.next = 17;
                break;
              }

              if (!(queryParams && queryParams.sm)) {
                _context5.next = 11;
                break;
              }

              _context5.next = 11;
              return postSampleId();

            case 11:
              formValues = queryParams && queryParams.ev && queryParams.sm ? (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, values), {}, {
                eventDetails: {
                  eventId: eventId,
                  sampleId: sampleId
                },
                confirmationCode: confirmationCode
              }) : values;
              _context5.next = 14;
              return dispatch((0, _novaFrontendRestClient.post)("".concat((0, _config.getApiBaseUrl)(), "/forms/").concat(formId), // un-comment for local backend validation and payment testing
              // `${getApiBaseUrl()}/forms/validate/${formId}`,
              'form/submission', {
                formId: formId
              }, formValues));

            case 14:
              response = _context5.sent;
              _context5.next = 20;
              break;

            case 17:
              _context5.next = 19;
              return dispatch((0, _novaFrontendRestClient.post)("".concat((0, _config.getApiBaseUrl)(), "/forms/").concat(formId, "/pages/").concat(page), // un-comment for local backend validation and payment testing
              // `${getApiBaseUrl()}/forms/validate/${formId}/pages/${page}`,
              'form/submission', {
                formId: formId
              }, values));

            case 19:
              response = _context5.sent;

            case 20:
              if (!response.response.ok) {
                _context5.next = 26;
                break;
              }

              // Form submitted fine
              if (!isLastPage) {
                nextPage();
              }

              if (isLastPage) {
                setState(function (prevState) {
                  return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                    submitted: true
                  });
                });
                window.onbeforeunload = undefined;
                isPaymentForm = form && form.pages.some(function (item) {
                  return item.type === 'payment';
                });
                eventTrackingEnabled = window.dataLayer;

                if (isPaymentForm && eventTrackingEnabled) {
                  (0, _setEcommerceTracking["default"])(values.donation.amount);
                }
              } // Redirect to success page if one exists
              // Otherwise display success message on form - see Form.js:115
              // If thank you page and event details are included in query string,
              // redirect to thank you page with confirmation code added


              if (isLastPage && queryParams && queryParams.redirect && queryParams.ev && queryParams.sm) {
                window.location.href = "".concat(queryParams.redirect, "?cc=").concat(confirmationCode); // If thank you page is included in query string, redirect to thank you page
              } else if (isLastPage && queryParams && queryParams.redirect) {
                window.location.href = queryParams.redirect; // If discoveryMethod is included in data, redirect to default thank you page and include in query string
                // The website will load dynamic content on the thank you page based on the discoveryMethod
              } else if (isLastPage && form && form.success && form.success.url && values !== null && values !== void 0 && (_values$discoveryMeth = values.discoveryMethod) !== null && _values$discoveryMeth !== void 0 && _values$discoveryMeth.reason) {
                window.location.href = "".concat(form.success.url, "?discoveryMethod=").concat(encodeURIComponent(values.discoveryMethod.reason));
              } else if (isLastPage && form && form.success && form.success.url) {
                window.location.href = form.success.url;
              }

              _context5.next = 33;
              break;

            case 26:
              if (!(response.response.status === 400)) {
                _context5.next = 31;
                break;
              }

              // Submission errors
              errors = convertToReduxFormErrors(response.payload);
              throw new _reduxForm.SubmissionError(errors);

            case 31:
              // API errors
              otherError = response.payload.code ? response.payload : {
                code: response.response.status,
                message: 'Unable to connect'
              };
              setState(function (prevState) {
                return (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, prevState), {}, {
                  formError: otherError
                });
              });

            case 33:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function onSubmit(_x, _x2, _x3) {
      return _ref4.apply(this, arguments);
    };
  }();

  var reset = function reset() {
    window.location.reload();
  }; // To support urls with and without a trailing slash, we trim a trailing
  // slash here. This is the only known way to achieve this currently due
  // to https://github.com/ReactTraining/react-router/issues/4841


  var newPath = function newPath(path) {
    return path.charAt(path.length - 1) === '/' ? "".concat(path, "step1") : "".concat(path, "/step1");
  };

  var formWithProps = /*#__PURE__*/_react["default"].createElement(_reactGoogleRecaptchaV.GoogleReCaptchaProvider, {
    reCaptchaKey: (0, _config.getGoogleReCaptchaKey)()
  }, /*#__PURE__*/_react["default"].createElement(_Form["default"], {
    asyncBlurFields: (0, _asyncValidateEmail.emailFields)(form),
    asyncValidate: _asyncValidateEmail.asyncValidateEmail,
    formStructure: form,
    onSubmit: onSubmit,
    location: location,
    queryParams: queryParams,
    submitted: submitted
  }));

  if (formError) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "section group"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-box"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Oops, something went wrong."), /*#__PURE__*/_react["default"].createElement("p", null, formError.message), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
      label: "Try again",
      onClick: reset,
      level: "primary",
      type: "button"
    })));
  }

  if (sampleIdError) {
    return /*#__PURE__*/_react["default"].createElement("section", {
      className: "section group"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "error-box"
    }, /*#__PURE__*/_react["default"].createElement("h2", null, "Oops, something went wrong."), /*#__PURE__*/_react["default"].createElement("p", null, sampleIdError.message), /*#__PURE__*/_react["default"].createElement("p", null, "Please find your Anthony Nolan volunteer at your event and hand back your wallet. Make sure you request a", ' ', /*#__PURE__*/_react["default"].createElement("strong", null, "new wallet and scan a new QR code"), " to apply to join the register."), /*#__PURE__*/_react["default"].createElement("p", null, "If you have any questions please contact your Anthony Nolan volunteer.")));
  }

  if (loading || !form) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "loader"
    }, "\xA0");
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("title", null, form.name, " | Anthony Nolan")), form.pages.length > 1 ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "".concat(match.path, "/:page"),
    render: function render() {
      return formWithProps;
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    exact: true,
    path: "".concat(match.path, "/"),
    render: function render(props) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
        to: "".concat(newPath(match.url)).concat(props.location.search)
      });
    }
  })) : formWithProps);
};

exports.FormScreen = FormScreen;

var _default = (0, _reactRouterDom.withRouter)((0, _reactRedux.connect)()(FormScreen));

exports["default"] = _default;